<template lang="pug">
  v-layout(align-start)
    v-flex
      v-card.pa-2(width='100vw' outlined color='grey_1')
        v-app-bar(dark color='primary')
          v-toolbar-title.headline KARDEX
        v-card-text(style='padding: 0px 16px 16px 16px;')
          v-row(dense)
            v-col(cols='12')
              v-card(color='white')
                v-card-subtitle.title(style='color: black; padding: 16px 16px 0px 16px;') Información Producto
                v-card-text(style='padding: 16px 16px 0px 16px;')
                  v-row(dense)
                    v-col(cols='12' sm='6' md='6')
                      v-autocomplete( autocomplete="off" dense outlined label="Producto" v-model='pro' :items="arraypro" @change="productoSeleccionado")
                    v-col(cols='12' sm='6' md='6')
                      v-select(dense outlined label="Moneda" v-model='moneda' :items="arrayMoneda" @change="productoSeleccionado")
                  v-row(dense)
                    v-col(cols='12' sm='12' md='4')
                      v-text-field(outlined dense v-model='form.nombre' readonly label='Descripcion')
                    v-col(cols='12' sm='12' md='4')
                      v-text-field(outlined dense v-model='form.marca' readonly label='Marca')
                    v-col(cols='12' sm='12' md='4')
                      v-text-field(outlined dense :value='form.unidad? form.unidad.descripcion : null' readonly label='Unidad de Venta')
            v-col(cols='12')
              v-card(color='white')
                v-card-text(style='padding: 16px 32px 16px 32px;')
                  v-row(dense)
                    v-col(cols='12' sm='12' md='12' )
                      v-data-table.elevation-4(item-key='kardex' :items='kardex' :loading='loading' loading-text='Cargando, por favor espere...')
                        template(v-slot:header='props')
                          thead.v-data-table-header
                            tr.headers
                              th.text-center.parent-header(colspan='3')
                              th.text-center.parent-header.header-entrada(colspan='3')
                                span Entrada
                              th.text-center.parent-header.header-salida(colspan='3')
                                span Salida
                              th.text-center.parent-header.header-existencia(colspan='3')
                                span Existencia
                            tr.sub-headers
                              th.text-center.child-header.concepto
                                span Fecha
                              th.text-center.child-header.concepto
                                span Concepto
                              th.text-center.child-header.concepto
                                span Almacen
                              th.text-center.child-header.entrada
                                span Unidades
                              th.text-center.child-header.entrada
                                span Valor Unit.
                              th.text-center.child-header.entrada
                                span Valor Total
                              th.text-center.child-header.salida
                                span Unidades
                              th.text-center.child-header.salida
                                span Valor Unit.
                              th.text-center.child-header.salida
                                span Valor Total
                              th.text-center.child-header.existencia
                                span Unidades
                              th.text-center.child-header.existencia
                                span Valor Unit.
                              th.text-center.child-header.existencia
                                span Valor Total
                        template(v-slot:item='props')
                          tr
                          td.lineaSeparador {{props.item.fechaMov}}
                          td.lineaSeparador {{props.item.referencia}}
                          td.lineaSeparador(v-if='!props.item.idAlmacen') {{ 'Sin Almacen' }}
                          td.lineaSeparador(v-else) {{ props.item.idAlmacen.descripcion }}
                          
                          //- para la entrada
                          //- unidades
                          td.lineaSeparador(v-if='props.item.movimiento === 1') {{props.item.cantidad}}
                          td.lineaSeparador(v-else) {{ '' }}

                          //- Valor Unit.
                          td.fila(v-if='props.item.movimiento === 1 ') {{ mostrarValorUnit(props.item.saldoMostrar, props.item.cantidad) }}
                          td.fila(v-else) {{ '' }}

                          //- Valor Total
                          td.fila(v-if='props.item.movimiento === 1') {{ valorTotal(props.item.saldoMostrar) }}
                          td.fila(v-else) {{ '' }}

                          //- para la salida
                          //- Unidades
                          td.lineaSeparador(v-if='props.item.movimiento === 2') {{props.item.cantidad}}
                          td.lineaSeparador(v-else) {{ '' }}

                          //- Valor Unit.
                          td.fila(v-if='props.item.movimiento === 2 ') {{ mostrarValorUnit(props.item.saldoMostrar, props.item.cantidad) }}
                          td.fila(v-else) {{ '' }}

                          //- Valor Total
                          td.fila(v-if='props.item.movimiento === 2') {{ valorTotal(props.item.saldoMostrar) }}
                          td.fila(v-else) {{ '' }}

                          //- para la existencia
                          td.lineaSeparador {{ props.item.cantidadDisp }}
                          td.fila {{ valorUnitExist(props.item.saldoMostrar, props.item.cantidad) }}
                          td.lineaFinal {{ valorTotalExist(props.item.saldoMostrar, props.item.cantidad, props.item.cantidadDisp) }}
                        template(v-slot:no-data)
                          h1 No hay movimientos para este producto
</template>

<script>
import Api from '@/services/methods'
export default {
  data: () => ({
    loading: true,

    arraypro: [],
    pro: '',
    kardex: [],
    arrayMoneda: [
      {
        text: 'Bolivar (Bs)',
        value: 'Bs'  
      },
      {
        text: 'Dolar ($)',
        value: 'Dolar'  
      }
    ],
    moneda: 'Bs',
    form: {
      nombre: '',
      unidad: '',
      marca: ''
    },
    headers: [
      { text: 'Fecha', sortable: false, class: 'concepto' },
      { text: 'Concepto', sortable: false, class: 'concepto' },
      { text: 'Almacen', sortable: false, class: 'concepto' },
      {
        text: 'Unidades',
        sortable: false,
        class: 'entrada'
      },
      {
        text: 'Valor Unit.',
        sortable: false,
        class: 'entrada'
      },
      {
        text: 'Valor Total',
        sortable: false,
        class: 'entrada'
      },
      {
        text: 'Unidades',
        sortable: false,
        class: 'salida'
      },
      {
        text: 'Valor Unit.',
        sortable: false,
        class: 'salida'
      },
      {
        text: 'Valor Total',
        sortable: false,
        class: 'salida'
      },
      { text: 'Unidades', sortable: false, class: 'saldo' },
      {
        text: 'Valor Unit.',
        sortable: false,
        class: 'saldo'
      },
      { text: 'Valor Total', sortable: false, class: 'saldo' }
    ]
  }),
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.listarProductos()
    },
    mostrarValorUnit: function(montoMostrar, cantidad) {
      if (cantidad === 0 && montoMostrar >= 0) return 0;
      else if(montoMostrar && montoMostrar >= 0) return Number.parseFloat(montoMostrar / cantidad ).toFixed(2);
      else return "No tiene mov. con la moneda asociada"
    },
    valorTotal: function (montoMostrar) {
      if (montoMostrar >= 0 ) return Number.parseFloat(montoMostrar).toFixed(2);
      else return null; 
    },
    valorUnitExist: function(montoMostrar, cantidad) {
      if (cantidad === 0 && montoMostrar >= 0) return montoMostrar;
      else if (montoMostrar && montoMostrar >= 0)return Number.parseFloat(montoMostrar / cantidad ).toFixed(2);
      else return "No tiene mov. con la moneda asociada";
    },
    valorTotalExist: function(montoMostrar, cantidad, cantidadDisp){
      if (cantidad === 0 && montoMostrar >= 0) return Number.parseFloat(montoMostrar * cantidadDisp).toFixed(2);
      else if (montoMostrar && montoMostrar >= 0) return Number.parseFloat(cantidadDisp * montoMostrar /cantidad ).toFixed(2);
      else return null;
    },
    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD')
    },
    functionBs (val) {
      return 'BsS ' + Number.parseFloat(val).toFixed(2)
    },
    productoSeleccionado () {
      this.kardex = []
      const producto = this.producto.find(producto => producto._id == this.pro)
      this.form.nombre = producto.nombre
      this.form.unidad = producto.unidadMedida
      if (producto.idMarca) this.form.marca = producto.idMarca.nombre
      else this.form.marca = 'No tiene'
      this.listarKardex(producto._id)
      console.log('paso 1')
      console.log(producto)
    },

    listarProductos () {
      Api.get('producto/all')
        .then(response => {
          this.producto = response.data
          this.producto.map(data => {
            this.arraypro.push({
              text: `${data.nombre} -- ${data.descripcion}`,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    listarKardex (id) {
      Api.get('kardex/producto/' + id)
        .then(response => {
          this.kardex = response.data
          console.log('paso 2')
          console.log(this.kardex)
          this.kardex.map(data => {
            data.fechaMov = this.formato(data.fechaMov)
            if (this.moneda === 'Bs') data.saldoMostrar = data.saldoBs
            if (this.moneda === 'Dolar') data.saldoMostrar = data.saldo
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    }
  }
}
</script>

<style lang="scss">
$green: rgb(107, 235, 107);
$red: rgb(235, 116, 107);
$blue: rgb(94, 189, 233);

.headers{
  th {
    border-left: 1px solid !important;
    border-right: 1px solid !important;
    border-top: 1px solid !important;
    border-bottom: 1px !important;
    span {
      color: black;
      font-size: 170%;
    }
  }
  .header-entrada {
    background-color: $green;
  }
  .header-salida {
    background-color: $red;
  }
  .header-existencia{
    background-color: $blue;
  }
}

.sub-headers {
  th {
    border-left: 1px solid !important;
    border-right: 1px solid !important;
    border-top: 1px solid !important;
    border-bottom: 1px solid !important;
    span {
      color: black;
      font-size: 100%;
    }
  }
  .entrada {
    background-color: $green;
  }
  .salida {
    background-color: $red;
  }
  .existencia {
    background-color: $blue;
  }

}

.lineaSeparador {
  border-left: 1px solid !important;
  border-bottom: 1px solid !important;
}

.lineaFinal {
  border-right: 1px solid !important;
  border-bottom: 1px solid !important;
}

.fila{
  border-bottom: 1px solid !important;
}

</style>
